<template>
  <div class="seomain">
    <st-header
      title="SKU列表"
      :back-able="true"
			:more-op="[{ val: 'startbatch', title: '批量处理' }]"
			@command="headercommand"
    >
      <template slot="header-right">
        <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span>
      </template>
    </st-header>

    <ul class="tab-tilte four">
      <li
        v-for="(item, index) in tabs"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ item.title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <div class="keyword">
      <van-search
        v-model="sku"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入sku"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div>
    <div class="tab-content tab-content-list">
      <div class="st-list-box pan-3">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				  <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
				    <div class="st-list-top" style="justify-content: space-between;">
							<div style="position: relative;">
								<div class="t-tit"  style="position: relative;top: 50%;transform: translateY(-50%);">{{ v.sku }}</div>
							</div>
				    </div>
				    <div class="st-list-main"
				    	@touchstart="touchstart"
				    	@touchmove="touchmove"
				    	@touchend="touchend"
				    	@click="checkItem(v.id)"
				    >
							<div class="list-checkbox" v-if="touchLong">
								<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
								<van-checkbox :value="checkList[v.id]"></van-checkbox>
							</div>
				      <p>品&emsp;&emsp;类：{{ v.category }}</p>
				      <p>产品名称：{{ v.name }}</p>
				      <p>品&emsp;&emsp;牌：{{ v.brand }}</p>
				      <p>型&emsp;&emsp;号：{{ v.model }}</p>
				      <p>料&emsp;&emsp;号：{{ v.upccoding }}</p>
				      <p>单&emsp;&emsp;位：{{ v.unit }}</p>
				      <p>状&emsp;&emsp;态：{{ v.status_text }}</p>
				      <p>创&nbsp;建&nbsp;&nbsp;人：{{ v.operator }}</p>
				      <p>创建时间：{{ v.createtime_text }}</p>
				      <p>更新时间：{{ v.updatetime_text }}</p>
				      
				    </div>
						<div class="st-list-bottom-2">
							<div style="flex:1;padding:0px 8px;height:44px;" v-if="v.status == 0 || v.status == '-1'">
								<div class="st-list-bottom-xs" style="background-color: orange;height: 42px;line-height: 42px;padding:0px;">
									<router-link :to="'/sku/save?id=' + v.id" class="st-opt-btn" style="margin-top: 8px;padding-top:14px;">编辑</router-link>
								</div>
							</div>

							<van-button v-if="v.status == 1"  @click="openApproveDetail(v.id)" type="primary" class="st-opt-btn" style="flex: 1;">审批详情</van-button>
						
						</div>
				   
				  </div>
				</van-list>
			</div>
      
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[type]"
				@command="batchCommand"
			></batch-btn>
		</div>

  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
export default {
  components: {
    "st-header": StHeader,
		'batch-btn': BatchBtn,
  },
  props: {},
	inject: ['reload'],
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
			tabs: [
				{ title: '全部', type: '0' },
				{ title: '待审核', type: '1' },
				{ title: '已上架', type: '2' },
				{ title: '已下架', type: '3' },
			],
      cur: 0,
			type: 0,
      show: !1,
			
      oneinfo: {},
      stlist: [],
      sku: "", // 关键字搜索
			
			// 批量操作相关
			checkList: {},
			batchBtnOptions: {},
			touchLong: false,
			
    };
  },
  watch: {
  	touchLong: function(nv, ov) {
  		this.checkList = {};
  		this.$forceUpdate();
  	}
  },
  computed: {},
	created() {},
  methods: {
		// 更多里的操作
		headercommand(val) {
			this[val]();
		},
		
		// 开启批量模式
		startbatch() {
			this.touchLong = true;
		},
    // 添加
    addOrder() {
      this.$router.push(`/sku/save`);
    },
		
		// 查看审批详情
		openApproveDetail(id) {
			this.$router.push(`/common/approveDetail/6?id=${id}`);
		},
   
    async get_st_list(e) {
      this.stlist = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("incomeorder_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
				this.type = this.tabs[activeIndex].type;
      }
			
			this.setBatchBtnOption();
    },
    changeActiveIndex(value) {
			this.touchLong = false;
      this.cur = value;
			this.type = this.tabs[value].type;
      window.sessionStorage.setItem("incomeorder_activeIndex", value);
    },
    // 分页
    async onLoad() {
			let type = this.tabs[this.cur]['type'];
      let result = await this.$post(this.$api.skulist, {
        sku: this.sku,
        tag: type,
        page: this.page,
      });
      if (result.data.list.length == 0) return (this.finished = true);
      // 进行操作
      this.stlist.push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },

    onSearch(val) {
			this.touchLong = false;
      this.stlist= [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
		
		// #region-start 批量操作相关方法
		// 开始触屏
		touchstart() {
			this.touchTimeOut = setTimeout(() => {
				this.touchLong = true;
			}, 2500)
		},
		touchmove() {
			clearTimeout(this.touchTimeOut);
		},
		touchend() {
			clearTimeout(this.touchTimeOut);
		},
		
		// 勾选
		checkItem(id) {
			this.checkList[id] = !this.checkList[id];
			this.$forceUpdate();
		},
		getCheckIds() {
			let ids = [];
			for (let i in this.checkList) {
				if (this.checkList[i]) {
					ids.push(i);
				}
			}
			
			return ids;
		},
		// 设置 批量操作的按钮
		setBatchBtnOption() {	
			let options = {};
			let oprator = {
				"del": { text: '删除', value: 'del' },
			};
			let option = [
				{ text: '操作', children: [],
				}
			];
			
			for(let tit in this.tabs) {
				let v = this.tabs[tit];
				let children = [];
				if (v.type == 0) {
					children = ['del'];
				}  else if (v.type == 1) {
					children = ['del'];
				} else if (v.type == 2) {
					children = ['del'];
				}
				if (children.length > 0)  options[v.type] = JSON.parse(JSON.stringify(option));
	
				children.forEach((child) => {
					if (options[v.type]) {
						options[v.type][0].children.push(oprator[child]);
					}
					
				})
			}
			
			this.batchBtnOptions = options;
		},
		// 批量处理
		batchCommand(sign, params) {
			console.log(sign);
			if (sign == 'cancel') {
				this.touchLong = false;
				return;
			}
			
			let checkedIds = this.getCheckIds();
			if (!checkedIds || Object.keys(checkedIds).length <= 0) {
				this.$toast.fail('请选择付款单');
				return;
			}
		
			// 删除
			if (sign == 'del') {
				checkedIds = checkedIds.join(',');
				this.del(checkedIds, this.$api.skuDel);
			}
		},

		// 删除订单
		del(id, api) {
			this.$confirm('您正在进行付款单删除操作，是否继续进行？').then((data) => {
				this.$post(api, {ids: id}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('删除成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
				})
			}).catch((e) => {
				console.log('您取消了删除操作');
			});
		},
		// #region-edn 批量操作相关方法
		
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.st-list-box{
	margin: 0px 24px;
	.st-list {
		border-radius: 5px;
	}
}
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.st-list-bottom-xs {
  border-radius: 5px;
  font-size: 14px;
}

.keyword {
  position: fixed;
  margin-bottom: 16px;
  width: 100%;
  top: 92px;
	.van-search {
		padding-left: 28px;
		padding-right: 28px;
	}
	
}
.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-2,.st-list-bottom-3 {
	background-color: white;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
}

.st-list-bottom-2 {
	.van-button {
		margin-top: 8px;
		width: 45%;
		border-radius: 8px;
	}
}

.st-list-bottom-3 {
	.van-button {
		width: 30%;
		border-radius: 8px;
	}
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.st-list-main {
	position: relative;
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.tab-tilte.four {
  display: flex;
}
.tab-tilte.four .text-center {
  flex: 1;
}
.st-btn-3 {
	width: 30%;
	height: 50%;
	border-radius: 5px;
}
</style>
